export { default } from './FacilitiesPage';
